import { render, staticRenderFns } from "./ActivixRichRadio.vue?vue&type=template&id=c9a1e928&"
import script from "./ActivixRichRadio.vue?vue&type=script&lang=js&"
export * from "./ActivixRichRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports